/* REACT */
import React, { useMemo, useState, useEffect } from 'react'

/* 3RD PARTIES */
import { connect } from 'react-redux'
import moment from 'moment'
import 'moment/locale/nl'

/* COMPONENTS */
import Rating from '../../../ui/rating/rating'

/* STORE */
import { setIsPopoverChatOpen } from '../../../../store/general/actions'

/* STYLES */
import {
  TrophyContainer,
  TrophyImage,
  ItemImageWrapper,
  ItemImage,
  Title,
  TitleWrapper,
  GridItemWrapper,
  TripTypeWrapper,
  TripTypeOnCard,
  TripDetailsWrapper,
  TripSecondaryDetailsWrapper,
  GridItemDetailsWrapper,
  TripPriceWrapper,
  TripPriceFlex,
  TripPrice,
  TripPriceDisclaimer,
  TripPriceSymbol,
  TripSecondaryDetailItemWrapper,
  TripSecondaryDetail,
  TripDuration,
  TripDescriptionWrapper,
  TripDescription,
  TripTypeLabelWrapper,
  TripTypeLabel,
  TripSecondaryDetailSeparator,
  TripRatingWrapper,
  TripDisclaimerWrapper,
  TripDisclaimer,
} from './style'

/* UTILS/CONSTANTS*/
import {
  CLOUDFRONT_BASE_URL,
  CLIENT_STYLINGS,
} from '../../../../utils/constants'
import { Analytics, getTranslations } from '../../../../utils'
import { logAction } from '../../../../utils/actionLogger'

import { LABEL_IMAGE_ICONS } from './label-icon'

/*ASSETS*/
const NoImage = `${CLOUDFRONT_BASE_URL}/assets/images/NoImage.png`
const PinImage = `${CLOUDFRONT_BASE_URL}/assets/icons/Pin.svg`

const TripItem = ({
  index,
  isLessThanLaptop,
  item,
  router,
  language,
  setIsPopoverChatOpen,
  key,
  openPopoverChatOnClickthrough,
  showRelevancyInfo,
  randomMatch,
  itemsPerRow,
  organizationDetails,
}) => {
  // SET MOMENT LOCALE TO CURRENT LANGUAGE
  moment.locale(language)

  const {
    name,
    images,
    price,
    destinations,
    label_image,
    duration,
    trip_info,
    label_card,
    rating_image,
    keywords,
    rating_value,
    rating_total_value,
    description,
    label_bottom,
    label_top,
  } = item

  const [tripPrice, setTripPrice] = useState(price)
  const [earlyBookingTripPrice, setEarlyBookingTripPrice] = useState(null)
  const [keywordsText, setKeywordsText] = useState(null)
  const [durationInDays, setDurationInDays] = useState(duration)

  const itemImage = images?.length ? images[0]?.url : NoImage

  const mouseDownCoords = e => {
    window.checkForDrag = e.clientX
  }

  const destinationsText = useMemo(() => {
    if (destinations?.length) {
      let text = ''
      let index = 0
      for (let destination of destinations) {
        if (index) {
          text += `, `
        }
        text += `${destination}`
        index += 1
      }
      return text
    }
    return ''
  }, [destinations])

  const priceParts = useMemo(() => {
    if (!tripPrice) return null
    const priceStr =
      typeof tripPrice === 'number' ? String(tripPrice) : String(tripPrice)
    const match = priceStr.match(/^\s*([€$])\s*(.+)$/)
    if (match) {
      return { symbol: match[1], amount: match[2] }
    }
    return { symbol: null, amount: priceStr }
  }, [tripPrice])

  if (!organizationDetails?.slug) {
    return null
  }

  return (
    <GridItemWrapper
      target={
        organizationDetails?.openNewTabOnClickthroughGrid ? '_blank' : '_self'
      }
      href={item.url}
      onClick={() => {
        Analytics.getInstance().sendEvent('maya_click_grid_item', {
          item_entity: 'trips',
          item_title: name,
          item_subtitle: tripPrice,
          item_type: label_image,
          item_destination: destinations[0],
          item_url: item.url,
        })
        logAction({
          name: 'url_click_grid',
          url: item.url,
          linkLabel: name,
        })
        if (openPopoverChatOnClickthrough) {
          setIsPopoverChatOpen(true)
        }
      }}
      itemsPerRow={itemsPerRow}
    >
      <GridItemDetailsWrapper id={`grid-item-details-wrapper-${index}`}>
        <ItemImageWrapper onMouseDown={e => mouseDownCoords(e)}>
          <ItemImage index={index} backgroundImage={itemImage}>
            {label_top === 'gold' || label_top === 'silver' ? (
              <TrophyContainer label_top={label_top}>
                <TrophyImage
                  xmlns='http://www.w3.org/2000/svg'
                  fill='none'
                  viewBox='0 0 20 20'
                >
                  <path
                    fill={'#440C4E'}
                    fill-rule='evenodd'
                    d='M18.2952 4.25717L16.3809 4.25717L16.3809 2.98099C16.3809 2.81175 16.3137 2.64945 16.194 2.52979C16.0743 2.41012 15.912 2.3429 15.7428 2.3429L4.25717 2.3429C4.08793 2.3429 3.92563 2.41012 3.80597 2.52979C3.6863 2.64945 3.61908 2.81175 3.61908 2.98099L3.61908 4.25717L1.7048 4.25717C1.36634 4.25717 1.04174 4.39162 0.802405 4.63095C0.563074 4.87029 0.428619 5.19489 0.428619 5.53335L0.428619 6.80953C0.428619 7.6557 0.764756 8.4672 1.36308 9.06553C1.65934 9.36179 2.01106 9.5968 2.39814 9.75713C2.78522 9.91747 3.2001 9.99999 3.61908 9.99999L3.9102 9.99999C4.28608 11.1912 5.00275 12.2461 5.97164 13.0344C6.94053 13.8227 8.11918 14.3098 9.3619 14.4355L9.3619 16.3809L7.44762 16.3809C7.27839 16.3809 7.11609 16.4481 6.99642 16.5678C6.87676 16.6875 6.80953 16.8498 6.80953 17.019C6.80953 17.1882 6.87676 17.3505 6.99642 17.4702C7.11609 17.5899 7.27839 17.6571 7.44762 17.6571L12.5524 17.6571C12.7216 17.6571 12.8839 17.5899 13.0036 17.4702C13.1232 17.3505 13.1904 17.1882 13.1904 17.019C13.1904 16.8498 13.1232 16.6875 13.0036 16.5678C12.8839 16.4481 12.7216 16.3809 12.5524 16.3809L10.6381 16.3809L10.6381 14.4331C13.1857 14.1755 15.2993 12.388 16.0682 9.99999L16.3809 9.99999C17.2271 9.99999 18.0386 9.66385 18.6369 9.06553C19.2352 8.4672 19.5714 7.6557 19.5714 6.80953L19.5714 5.53335C19.5714 5.19489 19.4369 4.87029 19.1976 4.63095C18.9582 4.39162 18.6336 4.25717 18.2952 4.25717ZM3.61908 8.72381C3.11138 8.72381 2.62448 8.52213 2.26548 8.16313C1.90648 7.80413 1.7048 7.31723 1.7048 6.80953L1.7048 5.53335L3.61908 5.53335L3.61908 8.08572C3.61908 8.29841 3.62944 8.51111 3.65018 8.72381L3.61908 8.72381ZM15.1047 8.01393C15.1047 10.8471 12.7916 13.1697 9.99999 13.1904C8.64613 13.1904 7.34772 12.6526 6.3904 11.6953C5.43308 10.738 4.89526 9.43958 4.89526 8.08572L4.89526 3.61908L15.1047 3.61908L15.1047 8.01393ZM18.2952 6.80953C18.2952 7.31723 18.0935 7.80413 17.7345 8.16313C17.3755 8.52213 16.8886 8.72381 16.3809 8.72381L16.341 8.72381C16.3672 8.48808 16.3805 8.25111 16.3809 8.01393L16.3809 5.53335L18.2952 5.53335L18.2952 6.80953Z'
                    clip-rule='evenodd'
                  ></path>
                </TrophyImage>
              </TrophyContainer>
            ) : null}
          </ItemImage>
        </ItemImageWrapper>
        <TripDetailsWrapper>
          {name || tripPrice || durationInDays ? (
            <TripSecondaryDetailsWrapper>
              {name ? (
                <>
                  <TitleWrapper id={`trip-title-wrapper-${index}`}>
                    <Title dangerouslySetInnerHTML={{ __html: name }}></Title>
                  </TitleWrapper>
                </>
              ) : null}

              {label_image ? (
                <TripSecondaryDetailItemWrapper>
                  {(() => {
                    const key = (label_image || '').toLowerCase()
                    const color =
                      CLIENT_STYLINGS[organizationDetails.slug].COLOR.FOREGROUND
                    return LABEL_IMAGE_ICONS[key]
                      ? LABEL_IMAGE_ICONS[key](color)
                      : null
                  })()}

                  <TripSecondaryDetail>{label_image}</TripSecondaryDetail>
                  <TripSecondaryDetailSeparator></TripSecondaryDetailSeparator>
                  <TripRatingWrapper>
                    {[...Array(Math.floor(rating_value))].map((_, index) => (
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        fill='none'
                        viewBox='0 0 24 24'
                        style={{
                          minWidth: '20px',
                          minHeight: '20px',
                          width: '20px',
                          height: '20px',
                          marginLeft: '-4px',
                        }}
                      >
                        <path
                          fill='#FFBB32'
                          d='M11.547 4.964a.5.5 0 0 1 .906 0l1.906 4.061a.5.5 0 0 0 .377.282l4.302.657a.5.5 0 0 1 .282.844l-3.144 3.223a.5.5 0 0 0-.135.43l.738 4.523a.5.5 0 0 1-.736.518L12.242 17.4a.5.5 0 0 0-.484 0l-3.801 2.1a.5.5 0 0 1-.736-.517l.738-4.524a.5.5 0 0 0-.135-.43L4.68 10.809a.5.5 0 0 1 .282-.844l4.302-.657a.5.5 0 0 0 .377-.282l1.906-4.06Z'
                        ></path>
                      </svg>
                    ))}
                  </TripRatingWrapper>
                  {label_card ? (
                    <TripTypeOnCard id={`trip-label-card-${index}`}>
                      <TripTypeLabelWrapper>
                        <TripTypeLabel>{label_card}</TripTypeLabel>
                      </TripTypeLabelWrapper>
                    </TripTypeOnCard>
                  ) : null}
                </TripSecondaryDetailItemWrapper>
              ) : null}

              {destinations?.length ? (
                <TripSecondaryDetailItemWrapper
                  style={{ alignItems: 'flex-start' }}
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    style={{
                      minWidth: '22px',
                      minHeight: '22px',
                      width: '22px',
                      height: '22px',
                      marginTop: '1px',
                    }}
                  >
                    <path
                      fill={
                        CLIENT_STYLINGS[organizationDetails.slug].COLOR
                          .FOREGROUND
                      }
                      fill-rule='evenodd'
                      d='M9.45 3.85718C8.81427 3.85718 8.19281 4.0457 7.66422 4.39889C7.13563 4.75209 6.72364 5.25409 6.48036 5.84143C6.23707 6.42877 6.17342 7.07507 6.29744 7.69858C6.42147 8.3221 6.7276 8.89483 7.17713 9.34437C7.62667 9.7939 8.1994 10.1 8.82292 10.2241C9.44643 10.3481 10.0927 10.2844 10.6801 10.0411C11.2674 9.79786 11.7694 9.38587 12.1226 8.85728C12.4758 8.32869 12.6643 7.70723 12.6643 7.0715C12.6643 6.21901 12.3257 5.40143 11.7229 4.79863C11.1201 4.19583 10.3025 3.85718 9.45 3.85718ZM9.45 9.00009C9.06856 9.00009 8.69569 8.88698 8.37853 8.67506C8.06138 8.46315 7.81419 8.16194 7.66821 7.80954C7.52224 7.45714 7.48405 7.06936 7.55847 6.69525C7.63288 6.32114 7.81656 5.9775 8.08628 5.70778C8.356 5.43806 8.69964 5.25438 9.07375 5.17997C9.44786 5.10555 9.83564 5.14374 10.188 5.28971C10.5404 5.43568 10.8416 5.68288 11.0536 6.00003C11.2655 6.31719 11.3786 6.69006 11.3786 7.0715C11.3786 7.58299 11.1754 8.07354 10.8137 8.43522C10.452 8.7969 9.96149 9.00009 9.45 9.00009ZM9.45 0C7.57518 0.00212686 5.77775 0.747841 4.45204 2.07354C3.12634 3.39925 2.38063 5.19667 2.3785 7.0715C2.3785 9.59474 3.5445 12.2691 5.75354 14.806C6.74613 15.9523 7.8633 16.9846 9.08437 17.8837C9.19246 17.9594 9.32124 18 9.45321 18C9.58519 18 9.71397 17.9594 9.82206 17.8837C11.0409 16.9842 12.1559 15.9519 13.1465 14.806C15.3523 12.2691 16.5215 9.59474 16.5215 7.0715C16.5194 5.19667 15.7737 3.39925 14.448 2.07354C13.1223 0.747841 11.3248 0.00212686 9.45 0ZM9.45 16.5537C8.12168 15.5091 3.66423 11.672 3.66423 7.0715C3.66423 5.53702 4.2738 4.06538 5.35884 2.98034C6.44388 1.8953 7.91552 1.28573 9.45 1.28573C10.9845 1.28573 12.4561 1.8953 13.5412 2.98034C14.6262 4.06538 15.2358 5.53702 15.2358 7.0715C15.2358 11.6704 10.7783 15.5091 9.45 16.5537Z'
                      clip-rule='evenodd'
                    ></path>
                  </svg>
                  <TripSecondaryDetail>{destinationsText}</TripSecondaryDetail>
                </TripSecondaryDetailItemWrapper>
              ) : null}

              {duration?.length ? (
                <TripSecondaryDetailItemWrapper>
                  <TripDuration>{duration}</TripDuration>
                </TripSecondaryDetailItemWrapper>
              ) : null}

              {description ? (
                <TripDescriptionWrapper>
                  <TripDescription>{description}</TripDescription>
                </TripDescriptionWrapper>
              ) : null}

              {tripPrice ? (
                <TripPriceWrapper>
                  <TripPriceFlex>
                    <TripPriceDisclaimer>
                      {getTranslations('trip_price_disclaimer')}
                    </TripPriceDisclaimer>
                    <TripPrice>
                      {priceParts?.symbol ? (
                        <TripPriceSymbol>{priceParts.symbol}</TripPriceSymbol>
                      ) : null}
                      {priceParts?.amount ?? tripPrice}
                    </TripPrice>
                  </TripPriceFlex>
                </TripPriceWrapper>
              ) : null}

              {label_bottom ? (
                <TripDisclaimerWrapper>
                  <TripDisclaimer>{label_bottom}</TripDisclaimer>
                </TripDisclaimerWrapper>
              ) : null}
            </TripSecondaryDetailsWrapper>
          ) : null}
        </TripDetailsWrapper>
      </GridItemDetailsWrapper>
    </GridItemWrapper>
  )
}

const mapStateToProps = state => ({
  openPopoverChatOnClickthrough: state?.general?.openPopoverChatOnClickthrough,
  organizationDetails: state?.maya?.organizationDetails,
})

const mapDispatchToProps = dispatch => ({
  setIsPopoverChatOpen: isOpen => dispatch(setIsPopoverChatOpen(isOpen)),
})

export default connect(mapStateToProps, mapDispatchToProps)(TripItem)
